import React from 'react'
import { ChevronDown, LoaderCircle } from 'lucide-react'
import { Button } from '@/components/ui/button'
import store from '../../../../state/store'

class RequestSearchButton extends React.Component {

  onRequestSearch = () => {
    store.emit('ui:tutor_searcher:open', this.props.tutoring_job.id)
  }

  renderText = () => {
    if (this.props.tutoring_job.tutor_search.searching === true) {
      return (
        <span className="inline-flex items-center gap-1">Searching<LoaderCircle className="size-3.5 animate-spin"/></span>
      )
    }
    else if (this.props.tutoring_job.tutor_search.searching === false) {
      return (
        <span>Request Search</span>
      )
    }

    return null
  }

  render() {
    return (
      <Button variant="outline" size="sm" onClick={this.onRequestSearch}>
        {this.renderText()}
        <ChevronDown className="size-3.5"/>
      </Button>
    )
  }
}

export default RequestSearchButton
